import styled from 'styled-components';
export const typographyComponents = {
    h1: styled.h1 `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
    h2: styled.h2 `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
    h3: styled.h3 `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
    h4: styled.h4 `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
    span: styled.span `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
    b: styled.b `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
    p: styled.p `
    ${({ theme, $variant }) => theme.typography[$variant]};
  `,
};
//# sourceMappingURL=BKJTypography.styled.js.map